(function () {
    'use strict';
    var controllerId = 'dipendenteAdd';
    angular.module('app').controller(controllerId, ['$scope', 'common', '$uibModalInstance', 'datacontext', '$translate', dipendenteAddFn]);

    function dipendenteAddFn($scope, common, $uibModalInstance, datacontext, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.dipendente = {};
        $scope.dipendente.Id = 0;
        $scope.dipendente.RuoloId = 2;

        $scope.item = {};
        $scope.item.ruoli = getRuoli();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function (isValid) {
            if (isValid) {
                var obj = {
                    "Matricola": $scope.dipendente.Matricola,
                    "Nominativo": $scope.dipendente.Cognome + ' ' + $scope.dipendente.Nome,
                    "Username": $scope.dipendente.Username,
                    "Email": $scope.dipendente.Email,
                    "Password": $scope.dipendente.Password,
                    "RuoloId": $scope.dipendente.RuoloId
                };

                addItem(obj).then(function (result) {
                    if (result == '502') logError($translate.instant('Username gia registrata'));
                    else if (result == '404') logError($translate.instant('Email gia registrata'));
                    else if (result == '406') logError($translate.instant('La matricola deve contenere 5 caratteri'));
                    else if (result == '501') logError($translate.instant('Matricola gia registrata'));
                    else if (result == '300') logError($translate.instant('Raggiunto il limite di utenti registrabili'));
                    else if (!result || result.Id == null || result.Id == 0) $uibModalInstance.close(null);
                    else $uibModalInstance.close(result);
                });
            }
        };

        function getRuoli() {
            return datacontext.role_getAll().then(function (data) {
                var roles = [];
                data.forEach(function (item) {
                    if (item.Name != "SUPER")
                        roles.push(item);
                });
                return $scope.item.ruoli = roles;
            });
        }

        function suggest () {
            if (!$scope.dipendente.Nome || !$scope.dipendente.Cognome)
                return;

            datacontext.user_suggestUserame($scope.dipendente.Nome, $scope.dipendente.Cognome).then(function (username) {
                if (!username || username.trim().length == 0)
                    return;

                $scope.dipendente.Username = username;

                datacontext.user_suggestPassword().then(function (password) {
                    if (!password || password.trim().length == 0)
                        return;

                    $scope.dipendente.Password = password;
                });
            });
        }

        function addItem(item) {
            return datacontext.dipendente_add(item).then(function (data) {
                return data;
            });
        }

        $scope.accountChange = function () {            
            if ($scope.item.accountEnabled) {
                suggest();
            }
            else {
                $scope.dipendente.Username = null;
                $scope.dipendente.Email = null;
                $scope.dipendente.Password = null;
            }
        };
    }
})();